/**
 * Empty GUID constant used to represent "no selection" or unset UUID values.
 * Backend uses this as the default value for nullable GUIDs.
 */
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
